import React from 'react';
import { graphql } from 'gatsby';
import Header from '../components/Header';
import SubHeader from '../components/SubHeader';
import Hero from '../components/Hero';
import HeroImg from '../images/hero/classmates-bg-two.jpg';
import Footer from '../components/Footer';
import Team from '../components/Team';
import Culture from '../components/Culture';
import Benefits from '../components/Benefits';
import Perks from '../components/Perks';
import JobsContainer from '../components/JobsContainer';
import Quote from '../components/Quote';
import About from '../components/About';

import sliderImageOne from '../images/slider-images/pc-carousel-01.jpg';
import sliderImageTwo from '../images/slider-images/pc-carousel-03.jpg';
import sliderImageThree from '../images/slider-images/pc-carousel-04.jpg';
import sliderImageFour from '../images/slider-images/pc-carousel-06.jpg';
import sliderImageFive from '../images/slider-images/pc-carousel-07.jpg';
import sliderImageSix from '../images/slider-images/pc-carousel-05.jpg';
import sliderImageSeven from '../images/slider-images/pc-carousel-08.jpg';

import flexibleImage from '../images/perks/flexible.jpg';
import gymImage from '../images/perks/gym.jpg';
import transitImage from '../images/perks/transit.jpg';
import beerImage from '../images/perks/beer.jpg';
import wfhImage from '../images/perks/wfh.jpg';
import growImage from '../images/perks/grow.jpg';
import seattleBM from '../images/sbm-best-award-2024.png';

const classmatesPerks = [
	{
		title: 'On-site gym',
		description: 'Work out during your lunch break! Our building has a gym and locker room with showers available for freshening up!',
		image: gymImage
	},
	{
		title: 'Commute Your Way',
		description: 'All full-time employees are eligible for a fully funded commuter ORCA Card as well as monthly benefits towards commute reduction or parking stipends.',
		image: transitImage
	},
	{
		title: 'Beer On Tap',
		description: 'Two beers on tap, rotating options. Available to be enjoyed for events and Friday Happy Hours.',
		image: beerImage
	},
	{
		title: 'Flexible Schedules',
		description: 'Early bird or night owl? Optimize your schedule and choose your own hours with flex time.',
		image: flexibleImage
	},
	{
		title: 'Hybrid Work Schedule',
		description: 'Employees have the option of a hybrid work schedule split between their home and the office.',
		image: wfhImage
	},
	{
		title: 'Grow With Us',
		description: 'Development and Training opportunities with expert trainers on-site as well as developed in-house by the HR team.',
		image: growImage
	}
];

export const Head = () => <title>PeopleConnect - Classmates</title>;

const Classmates = ({ data }) => {
	const teamMembers = data.allContentfulTeamMembers.edges.map(e => e.node),
		teamDepartments = data.allContentfulTeamDepartments.edges.map(e => e.node),
		jobs = data.allContentfulJobs.edges.map(e => e.node);

	const sliderImageList = [sliderImageOne, sliderImageTwo, sliderImageThree, sliderImageFour, sliderImageFive, sliderImageSix, sliderImageSeven];
	const tourVideoLink = 'https://www.youtube.com/embed/m0dBkYNtVMY?si=-FxHrDwHltunj__g';

	return (
		<div className="division-container">
			<Header />
			<SubHeader title="Classmates" linkOne="Product" />
			<Hero
				HeroImage={HeroImg}
				heroPage="classmates"
				headline="Classmates<span>&#174;</span>"
				subHeadline="Best in class for reconnecting with your high school friends, reunions and yearbooks."
				showVideo={true}
				videoLink={['https://www.youtube.com/embed/1Ia8LyMWtLc?si=88MarYAptfbdk-Cy', 'https://www.youtube.com/embed/9TOYdAtOp8M?feature=shared']}
			/>
			<About
				headingTitle="ABOUT CLASSMATES"
				headingSubTitle="Best In Class"
				aboutCopy="Founded in 1995, Classmates is one of the oldest social networking sites in the world. Search old yearbooks, find school friends and reconnect with your past."
			/>
			<div id="product" className="classmates-product">
				<div className="container-1200">
					<div>
						<div className="classmates-logo"></div>
						<h3>View your yearbook.</h3>
						<div className="laptop"></div>
						<p>
							Classmates is the best way to reconnect with high school friends and browse your yearbook online. We are devoted to bringing high school classes together. With the largest
							directory of high schools, class lists, and digital yearbooks available anywhere, covering over 70 million people and including maiden names, Classmates makes finding,
							reconnecting, and keeping up with your high school class fun and easy.
						</p>
						<a href="https://www.classmates.com/" target="_blank" rel="noreferrer">
							Classmates Website
						</a>
					</div>
				</div>
			</div>
			{teamMembers.length > 0 && <Team subHeading="Meet The Team" heading="You Can Sit With Us!" teamDepartments={teamDepartments} teamMembers={teamMembers} />}
			<Culture subHeading="Welcome to the Emerald City" heading="We're located in Bellevue." sliderImageList={sliderImageList} videoLink={tourVideoLink} />
			<Benefits
				division="Classmates"
				investmentCopy="The company match is dollar for dollar, up to 4% of your contribution to the plan. Contributions are automatically 100% vested, meaning there is no vesting schedule."
				insuranceCopy={
					<div>
						<p>We offer Anthem HMO and PPO medical, dental, and vision plans.</p>
						<ul className="insurance-list">
							<li className="nested-insurance">
								<p className="nested-font">100% of employee medical, dental and vision premiums are paid for by the company.</p>
							</li>
							<li className="nested-insurance">
								<p className="nested-font">70% of dependent medical, dental and vision premiums are paid for by the company.</p>
							</li>
						</ul>
					</div>
				}
				incomeCopy="We offer competitive salaries and a generous bonus program that rewards excellent work."
				timeOffCopy={
					<div>
						<p>We encourage all of our employees to maintain a healthy work/life balance by offering:</p>
						<ul className="time-off-list">
							<li className="nested-time-off">
								<p className="nested-font">10 Paid Holidays</p>
							</li>
							<li className="nested-time-off">
								<p className="nested-font">56 Hours of Sick Leave</p>
							</li>
							<li className="nested-time-off">
								<p className="nested-font">UNLIMITED Vacation</p>
							</li>
							<li className="nested-time-off">
								<p className="nested-font">Quarterly R & R Days</p>
							</li>
							<li className="nested-time-off">
								<p className="nested-font">Bereavement Pay</p>
							</li>
						</ul>
					</div>
				}
				snacksCopy="Our kitchen is fully stocked with a variety of delicious beverages and tasty treats! When working in the office, the company provides lunch, through Foodja, our 3rd party vendor."
				careCopy="The company subsidizes employee contributions when enrolled in the Dependent/Elder Care Flexible Spending Account."
				parentalCopy="The company offers employees 100% of their base salary during paid parental leave, allowing employees to focus on their families during those significant and exciting transitions."
			/>
			<Perks subHeading="But Wait There's More" heading="Perks that go above and beyond." perks={classmatesPerks} />
			<div className="classmates-awards">
				<div className="container-1200">
					<div className="classmates-award-item-wrap">
						<div className="heading">
							<p>THE VOTES ARE IN!</p>
							<h3>Classmates Gaining Recognition</h3>
							<p className="default">
								Our company was voted one of the best places to work in Washington by Seattle Business Magazine in 2023 and 2024. Join our team and see what all the fuss is about!
							</p>
						</div>
						<div className="classmates-best-workplace">
							<div>
								<p style={{ color: '#8A8A8A' }}>Seattle Business Magazine</p>
								<h3>Best Places to Work</h3>
								<p className="award-year">2023 & 2024</p>
							</div>
							<div className="classmates-award-image-wrap">
								<img src={seattleBM} alt="award-image" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<JobsContainer jobs={jobs} division="Classmates" />
			<Quote
				division="classmates"
				quote="I love working at PeopleConnect because I feel like my ideas can have a real impact at the company. Also, management helps employees feel empowered to speak up if something can be improved or fixed even if will be a difficult task. I also appreciate the work-life balance PeopleConnect offers that can be hard to find at technology companies."
				name="Nathan Knutzen"
				title="Director, Business Analytics"
			/>
			<Footer />
		</div>
	);
};

export const classmatesQuery = graphql`
	query classmatesQuery {
		allContentfulTeamMembers(filter: { division: { elemMatch: { name: { in: ["Classmates"] } } }, active: { eq: true } }, sort: [{ order: ASC }]) {
			edges {
				node {
					division {
						name
					}
					departments {
						name
					}
					title
					name
					bio {
						bio
					}
					order
					image {
						file {
							url
						}
						gatsbyImageData(layout: CONSTRAINED, width: 800)
					}
					altImage {
						file {
							url
						}
						gatsbyImageData(layout: CONSTRAINED, width: 800)
					}
				}
			}
		}
		allContentfulTeamDepartments(filter: { team_members: { elemMatch: { division: { elemMatch: { name: { in: ["Classmates"] } } } } } }, sort: [{ order: ASC }]) {
			edges {
				node {
					name
				}
			}
		}
		allContentfulJobs(filter: { active: { eq: true }, division: { name: { eq: "Classmates" } } }) {
			edges {
				node {
					position
					division {
						name
					}
					department {
						name
					}
					city
					state
					active
					link
					createdAt(formatString: "MMMM Do, YYYY")
				}
			}
		}
	}
`;

export default Classmates;
